"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ContextModal = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var typography_1 = require("@kaizen/typography");
var __1 = require("..");
var ContextModal_module_scss_1 = __importDefault(require("./ContextModal.module.scss"));
/**
 * {@link https://cultureamp.design/components/modal/#context-modals-previously-information-modal Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-modal--context-modal-example Storybook}
 */
var ContextModal = function (_a) {
    var isOpen = _a.isOpen, _b = _a.unpadded, unpadded = _b === void 0 ? false : _b, _c = _a.layout, layout = _c === void 0 ? "portrait" : _c, title = _a.title, onConfirm = _a.onConfirm, onAfterLeave = _a.onAfterLeave, _d = _a.confirmLabel, confirmLabel = _d === void 0 ? "Confirm" : _d, confirmWorking = _a.confirmWorking, automationId = _a.automationId, renderBackground = _a.renderBackground, children = _a.children, contentHeader = _a.contentHeader, image = _a.image, props = __rest(_a, ["isOpen", "unpadded", "layout", "title", "onConfirm", "onAfterLeave", "confirmLabel", "confirmWorking", "automationId", "renderBackground", "children", "contentHeader", "image"]);
    var onDismiss = confirmWorking ? undefined : props.onDismiss;
    var footerActions = [];
    var workingProps = confirmWorking
        ? {
            working: true,
            workingLabel: confirmWorking.label,
            workingLabelHidden: confirmWorking.labelHidden
        }
        : {};
    if (onConfirm) {
        var confirmAction = { label: confirmLabel, onClick: onConfirm };
        footerActions.push(__assign(__assign({}, confirmAction), workingProps));
    }
    if (props.secondaryLabel) {
        footerActions.push({
            label: props.secondaryLabel,
            onClick: props.onSecondaryAction,
            disabled: !!confirmWorking
        });
    }
    return (react_1["default"].createElement(__1.GenericModal, { isOpen: isOpen, onEscapeKeyup: onDismiss, onOutsideModalClick: onDismiss, automationId: automationId, onAfterLeave: onAfterLeave },
        react_1["default"].createElement("div", { className: ContextModal_module_scss_1["default"].modal },
            renderBackground && renderBackground(),
            react_1["default"].createElement(__1.ModalHeader, { onDismiss: onDismiss },
                react_1["default"].createElement("div", { className: (0, classnames_1["default"])(ContextModal_module_scss_1["default"].header, !unpadded && ContextModal_module_scss_1["default"].padded) },
                    react_1["default"].createElement(__1.ModalAccessibleLabel, null,
                        react_1["default"].createElement(typography_1.Heading, { variant: "heading-2", tag: "h2" }, title)))),
            contentHeader && (react_1["default"].createElement("div", { className: ContextModal_module_scss_1["default"].contentHeader }, contentHeader)),
            react_1["default"].createElement(__1.ModalBody, null,
                react_1["default"].createElement("div", { className: (0, classnames_1["default"])(ContextModal_module_scss_1["default"].contentLayout, ContextModal_module_scss_1["default"]["".concat(layout, "Contentlayout")]) },
                    image && react_1["default"].createElement("div", { className: ContextModal_module_scss_1["default"].image }, image),
                    react_1["default"].createElement("div", { className: ContextModal_module_scss_1["default"].content },
                        children,
                        onConfirm != null && (react_1["default"].createElement("div", { className: props.secondaryLabel
                                ? ContextModal_module_scss_1["default"].footerWithSecondaryAction
                                : ContextModal_module_scss_1["default"].footer }))))),
            react_1["default"].createElement(__1.ModalFooter, { variant: image ? "context" : undefined, actions: footerActions, appearance: "primary", automationId: automationId, unpadded: unpadded }))));
};
exports.ContextModal = ContextModal;
exports.ContextModal.displayName = "ContextModal";
//# sourceMappingURL=ContextModal.js.map